import React from "react";
import { GridActionsCellItem, GridColDef } from "@mui/x-data-grid";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { Card as MuiCard, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import OlogaPageHeader from "../../components/misc/OlogaPageHeader";
import styled from "@emotion/styled";
import { spacing } from "@mui/system";
import OlogaDataGrid from "../../components/tables/OlogaDataGrid";

const AssessmentRead: React.FC = () => {
  const Card = styled(MuiCard)(spacing);
  const navigate = useNavigate();

  const columns: GridColDef[] = [
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      editable: false,
    },

    {
      field: "actions",
      headerName: "Ações",
      flex: 0.5,
      editable: false,
      type: "actions",
      getActions: (params) => [
        <GridActionsCellItem
          icon={<VisibilityOutlinedIcon />}
          onClick={() => {
            navigate(`/assessments/edit`, {
              state: {
                AssessmentId: {
                  ...params.row,
                },
              },
            });
          }}
          label="Edit"
        />,
      ],
    },
  ];

  return (
    <React.Fragment>
      <OlogaPageHeader
        title={"Tools"}
        buttonLabel="Nova Avaliação"
        onClick={() => navigate("/assessments/create")}
      ></OlogaPageHeader>
      <Grid container>
        <Grid item xs={12}>
          <Card>
            <OlogaDataGrid url={"/tools"} columns={columns} />
          </Card>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default AssessmentRead;
